import React from "react";

const SavedApplication : React.FC = () => {
    return(
        <>
            Saved Application
        </>
    )
}

export default SavedApplication